<template>
    <div class="grid-item text-center">
        <div class="rule-or">
            <div class="ruled"></div>
            <span v-if="dividerCopy" class="copy-ruled">{{ dividerCopy }}</span>
            <div class="ruled"></div>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'SectionRule',
        props: {
            dividerCopy: {
                type: String,
                required: false,
            },
        },
    };
</script>
